import { customizeError, downloadFile, formatDate, generateBlob } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { getTemporaryUnionsCertificatePdf, getTemporaryUnionsSummary } from '../../services/temporaryUnions'

export const GET_TEMPORARY_UNIONS_SUMMARY = 'GET_TEMPORARY_UNIONS_SUMMARY'
export const GET_TEMPORARY_UNIONS_SUMMARY_ERROR = 'GET_TEMPORARY_UNIONS_SUMMARY_ERROR'
export const GET_TEMPORARY_UNIONS_SUMMARY_SUCCESS = 'GET_TEMPORARY_UNIONS_SUMMARY_SUCCESS'
export const onGetTemporaryUnionsSummary = makeActionCreator(GET_TEMPORARY_UNIONS_SUMMARY)
export const onGetTemporaryUnionsSummaryError = makeActionCreator(GET_TEMPORARY_UNIONS_SUMMARY_ERROR, 'payload')
export const onGetTemporaryUnionsSummarySuccess = makeActionCreator(GET_TEMPORARY_UNIONS_SUMMARY_SUCCESS, 'payload')
export const onGetTemporaryUnionsSummaryThunk = payload => async dispatch => {
  dispatch(onGetTemporaryUnionsSummary())

  try {
    const { data } = await getTemporaryUnionsSummary({
      dni: payload.dni
    })

    return dispatch(
      onGetTemporaryUnionsSummarySuccess(
        data.payload
          ? {
              unions: data.payload.utpVO.map(union => {
                return {
                  ID: union.idUTP,
                  bidID: union.bidID,
                  abilityStatus: {
                    ID: union.estadoHabilidad.id,
                    status: union.estadoHabilidad.glosa,
                    description: union.estadoHabilidad.descripcion,
                    reason: union.estadoHabilidad.motivo
                  },
                  suppliers: union.proveedoresUTP.map(supplier => {
                    return {
                      ID: supplier.id,
                      dni: supplier.rutProveedor,
                      businessName: supplier.razonSocial,
                      status: supplier.estado
                    }
                  }),
                  processes: union.procesosUTP.map(process => {
                    return {
                      ID: process.idLicitacion,
                      description: process.descripcionLicitacion,
                      awardDate: process.fechaAdjudicacion
                    }
                  })
                }
              })
            }
          : { unions: [] }
      )
    )
  } catch (error) {
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 403:
        reason = 'FORBIDDEN_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }
    return dispatch(
      onGetTemporaryUnionsSummaryError({
        error: customizeError({ originalError: error?.originalError, code: error?.code, reason }).toObject()
      })
    )
  }
}

export const GET_TEMPORARY_UNION_FILE = 'GET_TEMPORARY_UNION_FILE'
export const GET_TEMPORARY_UNION_FILE_ERROR = 'GET_TEMPORARY_UNION_FILE_ERROR'
export const GET_TEMPORARY_UNION_FILE_SUCCESS = 'GET_TEMPORARY_UNION_FILE_SUCCESS'
export const onGetTemporaryUnionCertificate = makeActionCreator(GET_TEMPORARY_UNION_FILE)
export const onGetTemporaryUnionCertificateError = makeActionCreator(GET_TEMPORARY_UNION_FILE_ERROR, 'payload')
export const onGetTemporaryUnionCertificateSuccess = makeActionCreator(GET_TEMPORARY_UNION_FILE_SUCCESS, 'payload')
export const onGetTemporaryUnionCertificateThunk = payload => async (dispatch, getState) => {
  dispatch(onGetTemporaryUnionCertificate())

  try {
    const { pdfDownload } = getState().temporaryUnions
    if (pdfDownload?.key === payload?.bidID) {
      downloadFile(pdfDownload?.blob, pdfDownload?.fileName)
      return dispatch(
        onGetTemporaryUnionCertificateSuccess({
          blob: pdfDownload?.blob,
          fileName: pdfDownload?.fileName,
          key: pdfDownload?.key
        })
      )
    }

    const { data, headers } = await getTemporaryUnionsCertificatePdf({
      bidID: payload.bidID
    })

    const blob = generateBlob(data, headers['content-type'])
    const date = formatDate(new Date(), 'yyyyMMdd_HH_mm')
    const fileName = `Certificado de habilidad_${date}.pdf`
    downloadFile(blob, fileName)

    return dispatch(
      onGetTemporaryUnionCertificateSuccess({
        blob,
        fileName,
        key: payload?.bidID
      })
    )
  } catch (error) {
    return dispatch(
      onGetTemporaryUnionCertificateError({
        error: customizeError({
          originalError: error?.originalError,
          code: error.code,
          reason: 'SOMETHING_WENT_WRONG_ERROR'
        }).toObject()
      })
    )
  }
}
